import React, { useState } from "react";
import styled from "styled-components";
import { ReactComponent as ViewIcon } from "../../../../assets/images/icons/view.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/images/icons/delete.svg";
import colors from "../../../../theme/color/ColorTheme";
import fontSize from "../../../../theme/fonts/FontTheme";

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  background: #fff;
  border-radius: 8px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
`;
const TableHead = styled.thead`
  background-color: ${colors.backgroundTintSecondary};
`;
const Th = styled.th`
  padding: 16px;
  font-weight: 500;
  font-size: ${fontSize.s};
  color: #727272;

  &:first-child {
    width: 300px;
  }
`;
const TableBody = styled.tbody``;

const Td = styled.td`
  padding: 14px 16px;
  font-size: ${fontSize.s};
  border-bottom: 1px solid ${colors.dash};
  vertical-align: middle;
  &:first-child {
    width: 300px;
  }
`;

const ProductCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
  }

  span {
    display: block;
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
`;

const ActionIcons = styled.div`
  display: flex;
  gap: 12px;
  svg {
    width: 24px;
    height: 24px;
    cursor: pointer;
    transition: fill 0.2s;

    &:hover {
      fill: #0070f3;
    }
  }
`;
const TableFooter = styled.tfoot``;
const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
`;

const Pagination = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const ArrowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  background: transparent;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: background 0.2s;

  &:hover {
    background: #f0f0f0;
  }

  svg {
    width: 20px;
    height: 20px;
    stroke: #555;
  }
`;
const Numbers = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;
const PaginationButton = styled.button`
  min-width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0 12px;
  border-radius: 50%;
  transition: all 0.2s ease;
  font-weight: 600;
  font-size: ${fontSize.s};

  &:hover {
    background: #f0f0f0;
  }

  &.active {
    background: #004181;
    color: #fff;
    border-color: #004181;
  }
`;

const CategoryTable = ({ categories }) => {
  const [page, setPage] = useState(1);

  return (
    <TableWrapper>
      <StyledTable>
        <TableHead>
          <tr>
            <Th>Category ID</Th>
            <Th>Category</Th>
            <Th>Quantity</Th>
            <Th>Sale</Th>
            <Th>Actions</Th>
          </tr>
        </TableHead>
        <TableBody>
          {categories.map((category) => (
            <tr key={category.id}>
              <Td>{category.id}</Td>
              <Td>{category.category}</Td>
              <Td>{category.quantity} items</Td>
              <Td>{category.sale} items</Td>
              <Td>
                <ActionIcons>
                  <ViewIcon />
                  <EditIcon />
                  <DeleteIcon />
                </ActionIcons>
              </Td>
            </tr>
          ))}
        </TableBody>
        <TableFooter>
          <tr>
            <Td colSpan={8}>
              <FooterWrapper>
                <div>Showing 10 entries</div>
                <Pagination>
                  <ArrowButton
                    onClick={() => setPage((p) => Math.max(p - 1, 1))}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15 18L9 12L15 6"
                        stroke="#555"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </ArrowButton>
                  <Numbers>
                    {[1, 2, 3].map((p) => (
                      <PaginationButton
                        key={p}
                        className={page === p ? "active" : ""}
                        onClick={() => setPage(p)}
                      >
                        {p}
                      </PaginationButton>
                    ))}
                  </Numbers>
                  <ArrowButton
                    onClick={() => setPage((p) => Math.min(p + 1, 3))}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 18L15 12L9 6"
                        stroke="#555"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </ArrowButton>
                </Pagination>
              </FooterWrapper>
            </Td>
          </tr>
        </TableFooter>
      </StyledTable>
    </TableWrapper>
  );
};

export default CategoryTable;
